import * as React from 'react';
import { connect } from 'react-redux';
import * as vars from '../consts/variables';
import { getEmailAddress } from '../helpers/contactInfoHelpers';
import { featureFlagEnabled } from '../helpers/featureFlagEnabled';
import { __ } from '../helpers/TranslationService';
import { MarketContext } from '../context/markets';
import { IFeatureFlag } from '../interfaces/IFeatureFlag';
import { EnvelopeIcon } from './Icons/EnvelopeIcon';
import { ChatBubbleIcon } from './Icons/ChatBubbleIcon';
import { PhoneIcon } from './Icons/PhoneIcon';
import { Link } from './Link';
import { TrackComponent } from './TrackComponent';

const style: Record<string, React.CSSProperties> = {
    contactButton: {
        padding: '10px 0px 6px',
        width: '48%',
        maxWidth: 140,
        textAlign: 'center',
        background: vars.acqa,
        color: vars.white,
        borderRadius: '5px',
        flex: '0 0 auto',
    },
    contactButtonOrange: {
        background: vars.orange,
        color: vars.indigo,
    },
    contactButtonIcon: {
        fill: vars.white,
    },
    contactButtonIconBlue: {
        fill: vars.indigo,
    },
    contactButtonText: {
        fontSize: '15px',
        display: 'block',
    },
    contactButtonsWrapper: {
        display: 'flex',
        width: '100%',
        padding: '10px 5% 25px',
        justifyContent: 'center',
    },
};
interface IStateProps {
    phoneNumber: string;
    countryCode: string;
    contact: string;
    featureFlags: IFeatureFlag[];
}

type Props = IStateProps;
export class ContactButtonClass extends React.Component<Props, {}> {
    static contextType = MarketContext;
    render() {
        const { isCruise1st } = this.context.markets;
        const TrackableLinkCallUs = TrackComponent(Link, {
            category: 'mobile-navigation-burger',
            action: 'call us',
        });
        const TrackableLinkWriteUs = TrackComponent(Link, {
            category: 'mobile-navigation-burger',
            action: 'write us',
        });
        const TrackableLinkContactSupport = TrackComponent(Link, {
            category: 'mobile-navigation-burger',
            action: 'contact support',
        });

        const contactButtonStyles = isCruise1st
            ? { ...style.contactButton, ...style.contactButtonOrange }
            : style.contactButton;

        const contactButtonIcon = isCruise1st
            ? style.contactButtonIconBlue
            : style.contactButtonIcon;

        const isContactFormEnabled =
            featureFlagEnabled(this.props.featureFlags, 'isContactForm') &&
            !!this.props.contact;

        return (
            <div style={style.contactButtonsWrapper}>
                {this.props.phoneNumber && (
                    <TrackableLinkCallUs
                        style={{ ...contactButtonStyles, ...{ marginRight: 10 } }}
                        href={`tel:${this.props.phoneNumber}`}
                        className="hideDesktop"
                    >
                        <PhoneIcon style={contactButtonIcon} width={28} height={28} />
                        <span style={style.contactButtonText}>{__('Call us', 'dreamlines')}</span>
                    </TrackableLinkCallUs>
                )}
                {isContactFormEnabled && (
                    <TrackableLinkContactSupport
                        style={contactButtonStyles}
                        href={this.props.contact}
                    >
                        <ChatBubbleIcon style={contactButtonIcon} width={28} height={28} />
                        <span style={style.contactButtonText}>
                            {__('Contact Support', 'dreamlines')}
                        </span>
                    </TrackableLinkContactSupport>
                )}
                {!isContactFormEnabled && (
                    <TrackableLinkWriteUs
                        style={contactButtonStyles}
                        href={`mailto:${getEmailAddress()}`}
                    >
                        <EnvelopeIcon style={contactButtonIcon} width={28} height={28} />
                        {
                            <span style={style.contactButtonText}>
                                {__('Write us', 'dreamlines')}
                            </span>
                        }
                    </TrackableLinkWriteUs>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    phoneNumber: state.pageData.brandConfig.phoneNumber,
    countryCode: state.pageData.appConfig.countryCode,
    contact: state.pageData.brandConfig.contactFormPagePath,
    featureFlags: state.pageData.featureFlags,
});

export const ContactButtons = connect<IStateProps, any, any>(mapStateToProps)(ContactButtonClass);
